import { Box, Typography, Stack, Button } from '@mui/material';
import { LocationOn, CameraAlt } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { ButtonPrimary } from '../../ui/ButtonPrimary';

export function PermissionRequestScreen({ 
  type = 'location', // 'location' ou 'camera'
  onRequest 
}) {
  const isLocation = type === 'location';
  const Icon = isLocation ? LocationOn : CameraAlt;
  const title = isLocation 
    ? 'Acesso à Localização Necessário' 
    : 'Acesso à Câmera Necessário';
  const description = isLocation
    ? 'Este aplicativo precisa acessar sua localização para identificar o posto de combustível mais próximo. Isso é obrigatório para o funcionamento do aplicativo.'
    : 'Este aplicativo precisa acessar sua câmera para capturar fotos dos bicos durante a aferição. Isso é obrigatório para o funcionamento do aplicativo.';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'primary.main',
        px: 3,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        style={{ width: '100%', maxWidth: 400 }}
      >
        <Stack spacing={4} alignItems="center" sx={{ textAlign: 'center' }}>
          <motion.div
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.1, type: 'spring', stiffness: 200 }}
          >
            <Box
              sx={{
                width: 120,
                height: 120,
                borderRadius: '50%',
                bgcolor: 'rgba(255, 255, 255, 0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 2,
              }}
            >
              <Icon sx={{ fontSize: 60, color: 'white' }} />
            </Box>
          </motion.div>

          <Box sx={{ width: '100%' }}>
            <Typography 
              variant="h4" 
              fontWeight={700} 
              gutterBottom
              sx={{ color: 'white', mb: 2 }}
            >
              {title}
            </Typography>
            <Typography 
              variant="body1" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.9)',
                lineHeight: 1.6,
                fontSize: '1rem'
              }}
            >
              {description}
            </Typography>
          </Box>

          <ButtonPrimary
            onClick={onRequest}
            size="large"
            sx={{
              minWidth: 200,
              py: 1.5,
              fontSize: '1.1rem',
              fontWeight: 600,
              bgcolor: 'white',
              color: 'primary.main',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.9)',
              },
            }}
          >
            Solicitar
          </ButtonPrimary>
        </Stack>
      </motion.div>
    </Box>
  );
}

